import { envConfig } from "@/libs/env-config";
import { IApiCollection, IApiCollectionResponse } from "../types/collection";
import { buildQueryString, getCommonHeaders, handleApiError } from "./common";

// Base URL
const PRODUCT_API_URL = envConfig.apiProductUrl;

// API Endpoints
const COLLECTIONS = "/collections";
const HARDCODED_HANDLE = "ryze-gums";

/**
 * Fetches all collections with their products
 * @returns Collection data from the API
 */
export const getCollectionsApi = async (): Promise<IApiCollectionResponse> => {
  try {
    const storeId = envConfig.storeId;
    const url = `${PRODUCT_API_URL}${COLLECTIONS}?storeId=${storeId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getCommonHeaders(),
    });

    if (!response.ok) {
      console.error(`API error: ${response.status} ${response.statusText}`);
      // Return empty collection data instead of throwing
      return { collections: [] };
    }

    return await response.json();
  } catch (error) {
    // Return empty collection data on error
    return handleApiError(error, "getCollections", { collections: [] });
  }
};

/**
 * Fetches a specific collection by handle
 * @param handle - The collection handle
 * @returns Collection data from the API
 */
export const getCollectionByHandleApi = async (
  _handle?: string, // Parameter kept for compatibility but not used
  params?: {
    [key: string]: string | number | boolean;
  }
): Promise<IApiCollection> => {
  try {
    const storeId = envConfig.storeId;
    const allParams = { ...params, storeId };
    const queryString = buildQueryString(allParams);
    const url = `${PRODUCT_API_URL}${COLLECTIONS}/handle/${HARDCODED_HANDLE}${queryString}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getCommonHeaders(),
    });

    if (!response.ok) {
      console.error(`API error: ${response.status} ${response.statusText}`);
      // Return empty collection data instead of throwing
      return { id: "", title: "", handle: "", products: [] };
    }

    return await response.json();
  } catch (error) {
    // Return empty collection data on error
    return handleApiError(error, `getCollectionByHandle:${HARDCODED_HANDLE}`,
      { id: "", title: "", handle: "", products: [] }
    );
  }
};
